
<template>
    <v-app id="overviewFeratel">
      <v-main>
      <v-container fluid>  
      <v-card>
        <v-card-title>Overview Feratel accommodations
        </v-card-title>
        <v-card-text color="success" class="d-flex align-center">
            <v-chip>{{ aantalHuizen }} Accommodations</v-chip>  &nbsp;
            <v-chip color="success">{{ aantalHuizenFeratel }} With working connection</v-chip>  &nbsp;
            <v-chip color="warning">{{ aantalHuizenFeratelGuestcard }} With Manual send Guestcard</v-chip>
            <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" placeholder="Search in all fields..." class="ml-8" style="max-width: 450px;" dense></v-text-field>
            <v-checkbox v-model="excludeTest" label="Exclude test accommodations" class="ml-6" hide-details style="margin-top: 0; margin-bottom: 0;"></v-checkbox>
        </v-card-text>
        <v-row dense no-gutters class="px-4">
            <v-col cols="1" class="mr-2">
                <v-text-field v-model="huis_code" label="Acco ID" hint="Search values beginning with..." @keyup.enter="getAccos" maxlength="15"></v-text-field>
              </v-col>
              <v-col cols="1" class="mr-2">
                <select_status_codes :selected_statcodes="statCodesSelected" field="statCodesSelected" :isClearable="true" @updateData="updateData" :visibleChips="1" :initializeEmpty="true"></select_status_codes>
              </v-col>
              <v-col cols="2" class="mr-2">
                <v-select v-model="huisFeratelStatus" label="Process status" :items="feratelStatusChoices" item-text="oms" item-value="value" clearable multiple></v-select>
              </v-col>
              <v-col cols="2" class="mr-2">
                <v-select v-model="plts_nr" :items="plts_nrKeuzesFiltered" item-value="plts_nr" item-text="plts_naam"
                  label="City" clearable>
                  <template v-slot:prepend-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-text-field v-model="searchCityInput" placeholder="Search"></v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                </v-select>
              </v-col>
            <v-col cols="2" class="mr-2">
                <v-select v-model="huisServiceTeam" label="Feratel Service team" :items="serviceTeamChoices" multiple></v-select>
            </v-col>
            <v-col cols="2" class="mr-2">
                <v-select v-model="huisGuestCard" label="Guestcard" :items="guestCardChoices2" item-text="oms" item-value="value" multiple></v-select>
            </v-col>
            <v-col cols="1" class="d-flex align-center">
                    <v-btn class="primary" small @click="getAccos" :loading="loading">Search</v-btn>
                </v-col>
        </v-row>
        <v-data-table
            :items="filteredItems"
            :search="search"
            :fixed-header=true
            :headers="getHeaders()" 
            :disable-pagination=true 
            :loading="loading"
            no-data-text="No accommodations to display" 
            :hide-default-footer="true" 
        >
            <template v-slot:item="props">
                <tr>
                <td @click="$router.open('/huis/onHuis/' + props.item.huis_encrid)" class="td-markup">
                    <div><a> {{ props.item.huis_code }} </a></div>
                    <div class="default-cursor"><span> {{ props.item.bedr_code }} </span><span class="ml-2 mr-2">-</span><span> {{ props.item.hstptaal_oms }} </span></div>
                    <div class="default-cursor">{{ props.item.cttptaal_oms }} </div>
                </td>
                <td class="td-markup default-cursor text-center">{{ props.item.stat_code }}</td>
                <td class="td-markup default-cursor text-center">
                    <v-icon>mdi-account</v-icon> {{ props.item.huis_aantpers_max }}
                </td> 
                <td class="td-markup default-cursor">{{ props.item.huis_feratel_oestat }}</td>
                <td class="td-markup default-cursor">{{ props.item.huis_feratel_betriebnr }}</td>
                <td class="td-markup default-cursor">{{ props.item.huis_feratel_loginname }}</td>
                <td class="td-markup default-cursor text-center">
                    <v-icon v-if="props.item.has_password" color="success">mdi-check-circle-outline</v-icon>
                    <v-icon v-else>mdi-close-circle-outline</v-icon>
                </td>
                <td class="td-markup default-cursor text-center">
                    <v-icon v-if="props.item.huis_feratel_hostbooking" color="success">mdi-check-circle-outline</v-icon>
                    <v-icon v-else>mdi-close-circle-outline</v-icon>
                </td>
                <td class="td-markup default-cursor text-center">
                    <v-tooltip v-if="props.item.huis_feratel_connection_check !== '' && props.item.huis_feratel_open_blocks !== ''" color="success" bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon color="success" v-bind="attrs" v-on="on">mdi-check-circle-outline</v-icon>
                        </template>
                        <span>Working connection since {{ props.item.huis_feratel_connection_check }}. Open blocks since {{ props.item.huis_feratel_open_blocks }}</span>
                    </v-tooltip>
                    <v-tooltip v-if="props.item.huis_feratel_open_blocks === '' && props.item.huis_feratel_connection_check !== ''" color="warning" bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon color="warning" v-bind="attrs" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        <span>Connection working, no open block</span>
                    </v-tooltip>
                    <v-icon v-if="props.item.huis_feratel_connection_check === ''">mdi-close-circle-outline</v-icon>
                </td>                
                <td class="td-markup default-cursor">{{ props.item.huis_feratel_status }}</td>
                <td class="td-markup default-cursor">
                    <div>{{ props.item.huis_plaats }}</div>
                    <div>{{ props.item.huis_naam }}</div>
                    <div v-if="props.item.connector!==''"> {{ props.item.connector }} - {{ props.item.park_naam }} </div>
                    <div v-if="props.item.connector!==''" class="tiny"> ({{ props.item.toname }}) </div>
                    <div v-if="props.item.stat_code ==='W'"><b>Last arrival:</b> {{ props.item.huis_last_arrivaldate ? new Date(props.item.huis_last_arrivaldate).toLocaleDateString('nl-NL', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '' }}</div>
                    <div v-else></div>
                </td>
                <td class="td-markup default-cursor">
                    <div> {{ props.item.huis_feratel_service }} </div>
                </td>
                <td class="td-markup default-cursor">
                    <div> {{ props.item.huis_feratel_guestcard }} </div>
                </td>                         
                </tr> 
            </template>

        </v-data-table>
      </v-card>  
      </v-container>
      </v-main>
      <navBar title="Ares - Various" :home="true" type="various" />    
    </v-app>
  </template>
  
  
  <script>
      import navBar from "@/components/ui/navbars/navbar.vue";
      import select_status_codes from "@/components/ui/selectors/select_status_codes.vue";
      export default {
          components: {
              navBar,
              select_status_codes,
          },
          data() {
              return {
                overviewFeratel: [],
                search: '',
                excludeTest: true,
                loading: false,
                // headers: [
                //     { text: 'Id', value: 'huov_code' },
                //     { text: 'Status', value: 'hust_code' },
                //     { text: 'Accommodation', value: 'huis_code' },
                //     { text: 'Booking', value: 'huov_dt' },
                //     { text: 'Persons', value: 'huov_pers' },
                //     { text: 'Arrival', value: 'huov_van_dat' },
                //     { text: 'Departure', value: 'huov_tm_dat' },
                //     { text: 'Guest', value: 'klnt_naam' },
                //     { text: 'Sales partner', value: 'inpt_naam' },
                //     { text: 'Travel Party', value: 'huov_travelparty_complete'},
                //     { text: 'Feratel Mblattnr', value: 'huov_feratel_mblattnr'},
                //     { text: 'Feratel Guid', value: 'huov_feratel_guid'},
                //     { text: 'Feratel Service team', value: 'huov_feratel_service'},
                //     { text: 'Days before arrival', value: 'huov_days_before_arrival'},
                //     { text: '', sortable: false, width: '7%' }
                // ],
                items:[],
                aantalHuizen: '',
                aantalHuizenFeratel: '',
                aantalHuizenFeratelGuestcard: '',
                huovVanDatVan: '',
                huovVanDatTm: '',
                serviceTeamChoices: [],
                guestCardChoices: [],
                guestCardChoices2: [],
                huisServiceTeam: [],
                huisGuestCard: [],
                huisFeratelStatus: [],
                feratelStatusChoices: [],
                statCodesSelected: [],
                huis_code: '',
                plts_nrKeuzes: [],
                plts_nr: '',
                searchCityInput: '',
                huovVanDatVanmenu: false,
                huovVanDatTmmenu: false,
              }  
          },
          computed: {
    filteredItems() {
      if (!this.excludeTest) return this.items;
      return this.items.filter(item => item.huis_type?.toLowerCase() !== 'test');
    },
    plts_nrKeuzesFiltered() {
      let cities = this.plts_nrKeuzes
      if (this.searchCityInput) {
        cities = cities.filter(x => {
          return x.plts_naam.toLowerCase().indexOf(this.searchCityInput.toLowerCase()) > -1;
        })
      }
      return cities
    }
  },
  created() {
    this.$axios
      .post("ares/json/ares/huis/getSearchHuisPlts.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getSearchHuisParam"
        },
        getSearchHuisParam: {}
      })
      .then(res => {
        if (res.data.error) {
          console.log(res.data.error);
        } else {
          this.plts_nrKeuzes = res.data.getSearchHuisParam.plts_nrKeuzes
        }
      });

  },
      mounted() {
                this.loading=true;
                this.getParams().then(() => {
                this.$axios
                  .post("ares/json/ares/task/various/huis/overviewFeratelHuis2.p", {
                      header: {
                          token: this.$session.get("ARES"),
                          clientSessionId: this.$session.id(),
                          request: "overviewFeratelHuis"
                      },
                      overviewFeratelHuis: {
                        serviceteam: this.huisServiceTeam,
                        guestcard: this.huisGuestCard,
                        huis_code: this.huis_code,
                        plts_nr: this.plts_nr,
                        feratel_stat: this.huisFeratelStatus,
                        huis_stat: this.statCodesSelected,
                      }
                  })
                  .then(res => {
                      if (res.data.error) {
                          console.log(res.data.error);
                      } else {
                        console.log(res.data.searchHuis);
                          this.items = res.data.searchHuis;
                          this.aantalHuizen = res.data.aantalHuizen;
                          this.aantalHuizenFeratel = res.data.aantalHuizen_Feratel;
                          this.aantalHuizenFeratelGuestcard = res.data.aantalHuizen_Manualguestcard;
                          this.serviceTeamChoices = res.data.serviceteamChoices;
                          this.guestCardChoices = res.data.guestCardChoices;
                          this.guestCardChoices2 = res.data.guestCardChoices2;
                          this.feratelStatusChoices = res.data.feratelStatusChoices;
                          this.loading = false;
                        
                      }
                  })
                  .finally(() => {
                      this.loading = false;
                  });
                });
          },
          methods: {
            getParams(){
                return this.$axios
                .post("ares/json/ares/task/various/huis/getOverviewFeratel2Params.p", {
                    header: {
                    token: this.$session.get("ARES"),
                    clientSessionId: this.$session.id(),
                    request: "getOverviewFeratel2Params"
                    },
                    getOverviewFeratel2Params: {}
                })
                .then(res => {
                    if (res.data.error) {
                    console.log(res.data.error);
                    } else {
                    this.param = res.data.getOverviewFeratel2Params;
                    this.statCodesSelected = res.data.getOverviewFeratel2Params.statKeuzes
                        .filter(stat => stat.statSelected === true)
                        .map(stat => stat.statCode);
                    }
                });
            },            
            getAccos() {
                this.loading=true;
                this.$axios
                .post("ares/json/ares/task/various/huis/overviewFeratelHuis2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "overviewFeratelHuis"
                    },
                    overviewFeratelHuis: {
                        serviceteam: this.huisServiceTeam,
                        guestcard: this.huisGuestCard,
                        huis_code: this.huis_code,
                        plts_nr: this.plts_nr,
                        huis_stat: this.statCodesSelected,
                        feratel_stat: this.huisFeratelStatus,
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        this.loading = false;
                    } else {
                        this.items = res.data.searchHuis;
                        this.aantalHuizen = res.data.aantalHuizen;
                        this.aantalHuizenFeratel = res.data.aantalHuizen_Feratel;
                        this.loading = false;
                    }
                })
            }, 
            updateData(data) {
                this[data.field] = data.value;
            },
            getColor(v){
                console.log(v);
                v===1?'warning':'success';
            },
            getHeaders(){
                return [
                    { text: "Accommodation", value: 'searchsethuis', width: "160px" },
                    { text: "State", value: 'stat_code', align: "center", width: "80px" },
                    { text: "Max persons", value: 'huis_aantpers_max', align: "center", width: "100px" },
                    { text: "Oestat", value: 'huis_feratel_oestat', width: "80px" },
                    { text: "Betrieb nr", value: 'huis_feratel_betriebnr', width: "100px" },
                    { text: "Login name", value: 'huis_feratel_loginname', width: "130px" },
                    { text: "Pwd", value: 'has_password', align: "center", width: "40px" },
                    { text: "Host booking", value: 'huis_feratel_hostbooking', align: 'center', width: "110px" },
                    { text: "Connection", value: 'huis_feratel_connection_check', align: 'center', width: "110px" },
                    { text: "Process status", value: 'huis_feratel_proces_status', width: "130px" },
                    { text: "Place/name", value: 'searchsetplace', width: "220px" },
                    { text: "Feratel Service Team", value: 'huis_feratel_service', width: "150px" },
                    { text: "Feratel Guest Card", value: 'huis_feratel_guestcard', width: "140px" },
                ];
            }
        
         }
      };
  
  </script>

<style>
.v-data-table th {
  white-space: nowrap;
}

.acco-error {
  background: transparent !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  border: 2px solid red;
  color: red;
  cursor: default;
}

.acco-warning {
  background: transparent !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  border: 2px solid orange;
  color: orange;
  cursor: default;
}
</style>
  